import type { MasterTask, Location } from '../types';

export const locations: Location[] = [
  {
    id: '6idUMtJzc2QvLXLxGoN1',
    name: 'RGS Øst - Vemmelev - Sikkerhed',
  },
  {
    id: '7iY45LhOYDPAkGzr8GC7',
    name: 'RGS Øst - Vemmelev - maskiner',
    latestAuditDate: new Date('2025-07-01'),
  },
];

export const auditCategories = [
  { id: 'RGS_audit_1', name: 'Perkolat' },
  { id: 'RGS_audit_2', name: 'Oplag og modtagelse' },
  { id: 'RGS_audit_3', name: 'Indretning' },
  { id: 'RGS_audit_4', name: 'Information' },
  { id: 'RGS_audit_5', name: 'Driftjournal/kontrolplan' },
  { id: 'RGS_audit_6', name: 'Maskiner og tekniske hjælpemidler' },
  { id: 'RGS_audit_7', name: 'Arbejdsmiljø' },
  { id: 'RGS_audit_8', name: 'Beredskab' },
  { id: 'RGS_audit_9', name: 'Kemiprodukter' },
  { id: 'RGS_audit_10', name: 'Olieudskiller og sandfang' },
  { id: 'RGS_audit_11', name: 'Miljøkortlægning' },
  { id: 'RGS_audit_12', name: 'Miljømål' },
  { id: 'RGS_audit_13', name: 'Øvrigt' },
];

export const masterTaskList: MasterTask[] = [
  // {
  //   id: 'task1',
  //   label: 'Intern audit',
  //   subTasks: [{ id: '1-1', label: 'Udeståender fra tidligere' }],
  //   category: 'Opfølgning',
  // },
  // {
  //   id: 'task2',
  //   label: 'Ekstern audit',
  //   subTasks: [{ id: '2-1', label: 'Udeståender fra tidligere' }],
  //   category: 'Opfølgning',
  // },
  // {
  //   id: 'task3',
  //   label: 'Internt tilsyn',
  //   subTasks: [{ id: '3-1', label: 'Udeståender fra tidligere' }],
  //   category: 'Opfølgning',
  // },
  // {
  //   id: 'task4',
  //   label: 'Eksternt tilsyn',
  //   subTasks: [{ id: '4-1', label: 'Udeståender fra tidligere' }],
  //   category: 'Opfølgning',
  // },
  // {
  //   id: 'task5',
  //   label: 'Pladsbesøg',
  //   subTasks: [{ id: '5-1', label: 'Udeståender fra tidligere' }],
  //   category: 'Opfølgning',
  // },
  {
    id: 'task6',
    label: 'Overløb',
    subTasks: [
      { id: '6-1', label: 'Perkolattank mangler alarm' },
      { id: '6-2', label: 'Perkolattank overfyldt' },
    ],
    category: {
      id: 'RGS_audit_1',
      label: 'Perkolat',
    },
  },
  {
    id: 'task7',
    label: 'Miljøfremmede stoffer i perkolat',
    subTasks: [
      { id: '7-1', label: 'Gentagne overskridelser' },
      { id: '7-2', label: 'Enkelt overskridelse' },
      { id: '7-3', label: 'Indskærpelse fra myndighed' },
    ],
    category: {
      id: 'RGS_audit_1',
      label: 'Perkolat',
    },
  },
  {
    id: 'task8',
    label: 'Analyser af perkolat',
    subTasks: [{ id: '8-1', label: 'Analyser mangler' }],
    category: {
      id: 'RGS_audit_1',
      label: 'Perkolat',
    },
  },
  {
    id: 'task9',
    label: 'Oprensning af perkolattanke',
    subTasks: [{ id: '9-1', label: 'Mangler oprensning' }],
    category: {
      id: 'RGS_audit_1',
      label: 'Perkolat',
    },
  },
  {
    id: 'task10',
    label: 'Afledt perkolatmængde',
    subTasks: [
      { id: '10-1', label: 'Registreringer' },
      { id: '10-2', label: 'Overskridelse i tilladt mængde' },
    ],
    category: {
      id: 'RGS_audit_1',
      label: 'Perkolat',
    },
  },
  {
    id: 'task11',
    label: 'Krav til oplag',
    subTasks: [
      { id: '11-1', label: 'Overdækning' },
      { id: '11-2', label: 'Mængde/kapacitet' },
      { id: '11-3', label: 'Oplagshøjde' },
      { id: '11-4', label: 'Afstandskrav mellem oplag' },
    ],
    category: {
      id: 'RGS_audit_2',
      label: 'Oplag og modtagelse',
    },
  },
  {
    id: 'task12',
    label: 'Sags- og fraktionsstyring',
    subTasks: [
      { id: '12-1', label: 'Jordstyring' },
      { id: '12-2', label: 'Tilsætning/stabilisering af jord' },
      { id: '12-3', label: 'Forurenede fraktioner' },
      { id: '12-4', label: 'Blanding af sager' },
      { id: '12-5', label: 'Videredisponering' },
    ],
    category: {
      id: 'RGS_audit_2',
      label: 'Oplag og modtagelse',
    },
  },
  {
    id: 'task13',
    label: 'Placering af oplag på anlæg',
    subTasks: [
      { id: '13-1', label: 'Oplag placeret uhensigtsmæssigt' },
      { id: '13-2', label: 'Oplag placeret ulovligt' },
    ],
    category: {
      id: 'RGS_audit_2',
      label: 'Oplag og modtagelse',
    },
  },
  {
    id: 'task32',
    label: 'Risiko for forurening ud over anlæg',
    subTasks: [
      { id: '32-1', label: 'Afskærmning' },
      { id: '32-2', label: 'Flyvsk affald' },
      { id: '32-3', label: 'Opkant' },
    ],
    category: {
      id: 'RGS_audit_2',
      label: 'Oplag og modtagelse',
    },
  },
  // Indretning
  {
    id: 'task33',
    label: 'Brønde',
    subTasks: [
      { id: '33-1', label: 'Oprensning' },
      { id: '33-2', label: 'Kontrol' },
      { id: '33-3', label: 'Tæthedsprøvning' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task34',
    label: 'Spildevandsledninger',
    subTasks: [
      { id: '34-1', label: 'Tæthedsprøvning' },
      { id: '34-2', label: 'Kamerainspektion' },
      { id: '34-3', label: 'Spuling' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task35',
    label: 'Betonelementer/betonblokke',
    subTasks: [
      { id: '35-1', label: 'Synlig armeringsjern' },
      { id: '35-2', label: 'Dårlig stand' },
      { id: '35-3', label: 'Mærkning' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task36',
    label: 'Støv',
    subTasks: [
      { id: '36-1', label: 'Støv fra køreveje' },
      { id: '36-2', label: 'Støv under knusning' },
      { id: '36-3', label: 'Støvklage' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task37',
    label: 'Lugt',
    subTasks: [
      { id: '37-1', label: 'Lugt på anlæg' },
      { id: '37-2', label: 'Lugtklage' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task38',
    label: 'Skiltning',
    subTasks: [
      { id: '38-1', label: 'Udgået skiltning' },
      { id: '38-2', label: 'Mangler skiltning' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task39',
    label: 'Hegn',
    subTasks: [{ id: '39-1', label: 'Skader på hegn' }],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task40',
    label: 'Alarmer',
    subTasks: [
      { id: '40-1', label: 'Er alarm installeret' },
      { id: '40-2', label: 'Påkrævet kontrol' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task41',
    label: 'Værksted',
    subTasks: [{ id: '41-1', label: 'Ryddelighed' }],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task42',
    label: 'Bygninger',
    subTasks: [
      { id: '42-1', label: 'Indeklima' },
      { id: '42-2', label: 'Stand, udvendig' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task43',
    label: 'Belysning',
    subTasks: [{ id: '43-1', label: 'Områder mangler belysning' }],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  {
    id: 'task44',
    label: 'Belægning og belægningskontrol',
    subTasks: [
      { id: '44-1', label: 'Manglelfuld belægningskontrol' },
      { id: '44-2', label: 'Skader på belægning' },
    ],
    category: {
      id: 'RGS_audit_3',
      label: 'Indretning',
    },
  },
  // {
  //   id: 'task14',
  //   label: 'Adgangsforhold',
  //   subTasks: [
  //     { id: '14-1', label: 'Beholderlader' },
  //     { id: '14-2', label: 'Adgangsveje blokeret' },
  //   ],
  //   category: {
  //     id: 'RGS_audit_3',
  //     label: 'Indretning',
  //   },
  // },

  // Information
  {
    id: 'task15',
    label: 'Oplæring/uddannelse',
    subTasks: [{ id: '15-1', label: 'Kursusbeviser ìkke tilgængelige' }],
    category: {
      id: 'RGS_audit_4',
      label: 'Information',
    },
  },
  {
    id: 'task45',
    label: 'Ledelsessystem',
    subTasks: [{ id: '45-1', label: 'Kendskab' }],
    category: {
      id: 'RGS_audit_4',
      label: 'Information',
    },
  },
  {
    id: 'task46',
    label: 'Registreringer',
    subTasks: [{ id: '46-1', label: 'Kendskab til oprettelse af registrering' }],
    category: {
      id: 'RGS_audit_4',
      label: 'Information',
    },
  },
  // {
  //   id: 'task16',
  //   label: 'Dokumentation',
  //   subTasks: [{ id: '16-1', label: 'Dokumentation' }],
  //   category: {
  //     id: 'RGS_audit_4',
  //     label: 'Information',
  //   },
  // },

  // Driftjournal/kontrolplan
  {
    id: 'task17',
    label: 'Årshjul',
    subTasks: [
      { id: '17-1', label: 'Vilkår' },
      { id: '17-2', label: 'Øvrige krav' },
      { id: '17-3', label: 'Dokumentation' },
    ],
    category: {
      id: 'RGS_audit_5',
      label: 'Driftjournal/kontrolplan',
    },
  },
  {
    id: 'task47',
    label: 'Driftstatus',
    subTasks: [{ id: '47-1', label: 'Registrering af driftstatus' }],
    category: {
      id: 'RGS_audit_5',
      label: 'Driftjournal/kontrolplan',
    },
  },
  // {
  //   id: 'task18',
  //   label: 'Kontrolplan',
  //   subTasks: [{ id: '18-1', label: 'Kontrolplan' }],
  //   category: {
  //     id: 'RGS_audit_5',
  //     label: 'Driftjournal/kontrolplan',
  //   },
  // },
  // Maskiner og tekniske hjælpemidler
  {
    id: 'task19',
    label: 'Maskiner med tilbehør',
    subTasks: [
      { id: '19-1', label: 'Eftersyn' },
      { id: '19-2', label: 'Stand' },
    ],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task48',
    label: 'El-værktøj',
    subTasks: [
      { id: '48-1', label: 'Eftersyn' },
      { id: '48-2', label: 'Stand' },
      { id: '48-3', label: 'Placering' },
    ],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task49',
    label: 'Løftegrej',
    subTasks: [
      { id: '49-1', label: 'Eftersyn' },
      { id: '49-2', label: 'Stand' },
      { id: '49-3', label: 'Placering' },
    ],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task50',
    label: 'Diseltanke',
    subTasks: [
      { id: '50-1', label: 'Eftersyn' },
      { id: '50-2', label: 'Tankattest' },
      { id: '50-3', label: 'Spildbakke' },
      { id: '50-4', label: 'Tegn på utæthed' },
    ],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task51',
    label: 'Porte',
    subTasks: [{ id: '51-1', label: 'Eftersyn' }],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task52',
    label: 'Pumper',
    subTasks: [
      { id: '52-1', label: 'Eftersyn' },
      { id: '52-2', label: 'Alarm' },
    ],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task53',
    label: 'Stiger',
    subTasks: [{ id: '53-1', label: 'Lovpligtig stigekontrol' }],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task54',
    label: 'Trykbærende udstyr herunder kompressorer',
    subTasks: [{ id: '54-1', label: 'Lovpligtig eftersyn' }],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task20',
    label: 'Tekniske hjælpemidler',
    subTasks: [{ id: '20-1', label: 'Tekniske hjælpemidler' }],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  {
    id: 'task55',
    label: 'Andet udstyr',
    subTasks: [
      { id: '55-1', label: 'Lifte' },
      { id: '55-2', label: 'Svejsning' },
      { id: '55-3', label: 'Udsugning' },
    ],
    category: {
      id: 'RGS_audit_6',
      label: 'Maskiner og tekniske hjælpemidler',
    },
  },
  // {
  //   id: 'task20',
  //   label: 'Tekniske hjælpemidler',
  //   subTasks: [{ id: '20-1', label: 'Tekniske hjælpemidler' }],
  //   category: {
  //     id: 'RGS_audit_6',
  //     label: 'Maskiner og tekniske hjælpemidler',
  //   },
  // },
  // Arbejdsmiljø
  {
    id: 'task56',
    label: 'APV processer',
    subTasks: [{ id: '56-1', label: 'Kendskab' }],
    category: {
      id: 'RGS_audit_7',
      label: 'Arbejdsmiljø',
    },
  },
  {
    id: 'task57',
    label: 'APV handleplaner',
    subTasks: [{ id: '57-1', label: 'Kendskab' }],
    category: {
      id: 'RGS_audit_7',
      label: 'Arbejdsmiljø',
    },
  },
  {
    id: 'task58',
    label: 'Sikkerhedsmæssige risici',
    subTasks: [{ id: '58-1', label: 'Nærved-hændelser' }],
    category: {
      id: 'RGS_audit_7',
      label: 'Arbejdsmiljø',
    },
  },
  // {
  //   id: 'task21',
  //   label: 'Arbejdspladsens indretning',
  //   subTasks: [{ id: '21-1', label: 'Arbejdspladsens indretning' }],
  //   category: {
  //     id: 'RGS_audit_7',
  //     label: 'Arbejdsmiljø',
  //   },
  // },
  // {
  //   id: 'task22',
  //   label: 'Personlige værnemidler',
  //   subTasks: [{ id: '22-1', label: 'Personlige værnemidler' }],
  //   category: {
  //     id: 'RGS_audit_7',
  //     label: 'Arbejdsmiljø',
  //   },
  // },
  // {
  //   id: 'task23',
  //   label: 'Støv- og støjbeskyttelse',
  //   subTasks: [{ id: '23-1', label: 'Støv- og støjbeskyttelse' }],
  //   category: {
  //     id: 'RGS_audit_7',
  //     label: 'Arbejdsmiljø',
  //   },
  // },
  {
    id: 'task24',
    label: 'Beredskabsplan',
    subTasks: [
      { id: '24-1', label: 'Udgået version' },
      { id: '24-2', label: 'Ikke ophængt' },
    ],
    category: {
      id: 'RGS_audit_8',
      label: 'Beredskab',
    },
  },
  {
    id: 'task25',
    label: 'Brandslukkere',
    subTasks: [
      { id: '25-1', label: 'Manglende eftersyn' },
      { id: '25-2', label: 'Brandslukker i maskine' },
      { id: '25-3', label: 'Placering' },
      { id: '25-4', label: 'Brugte brandslukkere' },
    ],
    category: {
      id: 'RGS_audit_8',
      label: 'Beredskab',
    },
  },
  {
    id: 'task59',
    label: 'Førstehjælpsudstyr',
    subTasks: [
      { id: '59-1', label: 'Manglende eftersyn' },
      { id: '59-2', label: 'Brugt og kræver erstatning' },
      { id: '59-3', label: 'Placering' },
      { id: '59-4', label: 'Redningsmulighed fra bassin' },
    ],
    category: {
      id: 'RGS_audit_8',
      label: 'Beredskab',
    },
  },
  {
    id: 'task60',
    label: 'Sikkerhedsoversigt',
    subTasks: [
      { id: '60-1', label: 'Udgået version' },
      { id: '60-2', label: 'Ikke ophængt' },
    ],
    category: {
      id: 'RGS_audit_8',
      label: 'Beredskab',
    },
  },
  {
    id: 'task61',
    label: 'Sikkerhedsrunderinger',
    subTasks: [{ id: '61-1', label: 'Ikke udført som påkrævet' }],
    category: {
      id: 'RGS_audit_8',
      label: 'Beredskab',
    },
  },
  {
    id: 'task62',
    label: 'Værnemidler',
    subTasks: [
      { id: '62-1', label: 'Mangelfuld brug' },
      { id: '62-2', label: 'Tilgængelighed' },
      { id: '62-3', label: 'Udløbsdato' },
    ],
    category: {
      id: 'RGS_audit_8',
      label: 'Beredskab',
    },
  },
  {
    id: 'task63',
    label: 'Risiko for brand',
    subTasks: [
      { id: '63-1', label: 'Krav i brandtekniske retningslinjer' },
      { id: '63-2', label: 'Krav i brandteknisk tilladelse' },
    ],
    category: {
      id: 'RGS_audit_8',
      label: 'Beredskab',
    },
  },
  // Kemiprodukter
  {
    id: 'task64',
    label: 'Sikkerhedsdatablad',
    subTasks: [{ id: '64-1', label: 'QR-kode tilgængelig' }],
    category: {
      id: 'RGS_audit_9',
      label: 'Kemiprodukter',
    },
  },
  {
    id: 'task65',
    label: 'Kemisk APV',
    subTasks: [{ id: '65-1', label: 'QR-kode tilgængelig' }],
    category: {
      id: 'RGS_audit_9',
      label: 'Kemiprodukter',
    },
  },
  {
    id: 'task66',
    label: 'Bruttoliste',
    subTasks: [
      { id: '66-1', label: 'Kendskab' },
      { id: '66-2', label: 'Anvender ikke godkendt kemiprodukt' },
    ],
    category: {
      id: 'RGS_audit_9',
      label: 'Kemiprodukter',
    },
  },
  {
    id: 'task67',
    label: 'Opbevaring',
    subTasks: [{ id: '67-1', label: 'Spildbakke, kemiskab' }],
    category: {
      id: 'RGS_audit_9',
      label: 'Kemiprodukter',
    },
  },
  // {
  //   id: 'task26',
  //   label: 'Kemisk opbevaring',
  //   subTasks: [{ id: '26-1', label: 'Kemisk opbevaring' }],
  //   category: {
  //     id: 'RGS_audit_9',
  //     label: 'Kemiprodukter',
  //   },
  // },

  {
    id: 'task27',
    label: 'Tømning',
    subTasks: [
      { id: '27-1', label: 'Olieudskiller mangler tømning' },
      { id: '27-2', label: 'Sandfang mangler oprensning' },
    ],
    category: {
      id: 'RGS_audit_10',
      label: 'Olieudskiller og sandfang',
    },
  },
  {
    id: 'task68',
    label: 'Kontrol',
    subTasks: [
      { id: '68-1', label: 'Olieudskiller mangler kontrol' },
      { id: '68-2', label: 'Sandfang mangler kontrol' },
      { id: '68-3', label: 'Tæthedsprøvning' },
    ],
    category: {
      id: 'RGS_audit_10',
      label: 'Olieudskiller og sandfang',
    },
  },

  // {
  //   id: 'task28',
  //   label: 'Sandfang',
  //   subTasks: [{ id: '28-1', label: 'Sandfang' }],
  //   category: {
  //     id: 'RGS_audit_10',
  //     label: 'Olieudskiller og sandfang',
  //   },
  // },
  {
    id: 'task29',
    label: 'Miljøkortlægning',
    subTasks: [{ id: '29-1', label: 'Skal opdateres' }],
    category: {
      id: 'RGS_audit_11',
      label: 'Miljøkortlægning',
    },
  },
  {
    id: 'task30',
    label: 'Miljømål',
    subTasks: [
      { id: '30-1', label: 'Dieselforbrug' },
      { id: '30-2', label: 'Minimere udledt mængde perkolat' },
      { id: '30-3', label: 'Elforbrug' },
      { id: '30-4', label: 'Skift fra dielsel til el' },
    ],
    category: {
      id: 'RGS_audit_12',
      label: 'Miljømål',
    },
  },
  {
    id: 'task31',
    label: 'Øvrige',
    subTasks: [],
    category: {
      id: 'RGS_audit_13',
      label: 'Øvrige',
    },
  },
].sort((a, b) => a.label.localeCompare(b.label, 'da-DK', { sensitivity: 'base' }));
